import { Controller } from 'stimulus';

/**
 * @class
 * @alias MoodboardDropdownTriggerController
 */
export default class extends Controller {
  static outlets = ['moodboard--dropdown-menu'];
  static targets = ['indicator'];
  static classes = ['active'];

  disconnect() {
    // TODO: we should remove dropdowns on disconnect, but we can't currently say for sure if
    //   disconnect was triggered by element entirely removed, or if it was caused by element
    //   moved (e.g. removed and returned back again). I (Andrii) would think about workaround
    //   in meantime.
    // if (this.moodboardDropdownMenuOutlet.inPopoverContainer) {
    //   this.moodboardDropdownMenuOutlet.element.remove();
    // }
  }

  moodboardDropdownMenuOutletConnected(outlet) {
    outlet.trigger = this;
  }

  /**
   * @param {MouseEvent} e
   */
  toggle(e) {
    const { target } = e;

    if (this.moodboardDropdownMenuOutlet.element.contains(target)) {
      return;
    }

    if (this.element.contains(target)) {
      if (this.element.dataset['editorButton'] && !this.moodboardDropdownMenuOutlet.visible) {
        window.ed.featureActionsService.add('top_bar_history_panel_opened');
      }
      this.moodboardDropdownMenuOutlet.visible = !this.moodboardDropdownMenuOutlet.visible;

      return;
    }

    this.moodboardDropdownMenuOutlet.visible = false;
  }

  hide() {
    this.moodboardDropdownMenuOutlet.visible = false;
  }

  set visible(value) {
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.classList.toggle('-scale-y-100', value);
    }

    if (this.hasActiveClass) {
      this.activeClasses.forEach((activeClass) => {
        this.element.classList.toggle(activeClass, value);
      });
    }
  }
}
